import { Form, Formik } from "formik";
import { FC } from "react";
import { object, string } from "yup";
import { Button, Input, Select } from "../../../custom";
import styles from "../styles.module.scss";
import { validator } from "../../../utils/validator";

const REFEREE_CATEGORIES = [
  { id: 0, name: "Supervisor" },
  { id: 1, name: "Lecturer" },
  { id: 2, name: "Professional" },
];

interface ComponentProps {
  isLoading: boolean;
  buttonText: string;
  titleOptions: Title[];
  onSubmit: (values: ReferenceFormValues) => void;
}

const ReferenceForm: FC<ComponentProps> = ({
  buttonText,
  isLoading,
  titleOptions,
  onSubmit,
}) => {
  const validationSchema = object().shape({
    titleId: string().required("Title is required"),
    refereeName: string().required("Referee name is required"),
    refereeEmail: validator.email,
    refereeCategory: string().required("Referee category is required"),
  });

  return (
    <Formik<ReferenceFormValues>
      initialValues={{
        titleId: "",
        refereeName: "",
        refereeEmail: "",
        refereeCategory: "",
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {() => (
        <Form>
          <div className={styles.nogrid}>
            <Select
              name="titleId"
              label="Title*"
              placeholder="Select title"
              options={titleOptions.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.titleName}
                </option>
              ))}
            />
            <Input
              name="refereeName"
              label="Referee Name*"
              placeholder="Enter referee full name"
            />
          </div>

          <br />

          <div className={styles.nogrid}>
            <Input
              name="refereeEmail"
              label="Referee Email*"
              placeholder="Enter referee email"
            />
            <Select
              name="refereeCategory"
              label="Referee Category*"
              placeholder="Select category"
              options={REFEREE_CATEGORIES.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            />
          </div>

          <br />

          <div className={styles.buttonWrapper}>
            <Button
              type="submit"
              text={buttonText}
              isLoading={isLoading}
              className={styles.buttonSize}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ReferenceForm;